import { ReactComponent as DeleteIcon } from '@assets/icons/icon-material-delete.svg';
import { ReactComponent as EditIcon } from '@assets/icons/icon-material-edit.svg';
import { useModal } from '@hooks';
import { ExtraServiceStatus } from '@shared/enums';
import apiClient from '@contexts/AuthContext/apiClient';
import rowStyles from '@styles/components/extra-services-row.module.scss';
import styles from '@styles/components/table.module.scss';
import { message } from 'antd';
import moment from 'moment';
import React from 'react';
import ExtraServicesModal from '../ExtraServicesModal/CreateExtraServiceModal';
import useToast from 'apps/agora/src/hooks/useToast';
import { logger } from '../../../../utils/logger';

// TODO Refactor any types
interface Props {
  selectedDate: any;
  extraService: any;
  completedNumber?: number;
  isEven: boolean;
  handleSelected: (extraService: any) => void;
  selectAll: boolean;
  selectedItems: any[];
  handleRowTouched: () => void;
  index: number;
}

const ExtraServicesRow: React.FC<Props> = ({
  selectedDate,
  extraService,
  isEven,
  handleSelected,
  selectAll,
  selectedItems,
  handleRowTouched,
  index,
}) => {
  const [EditServiceModal, showEditModal] = useModal(ExtraServicesModal);

  const toast = useToast();

  const classes = `${styles.gridTableRow} ${
    isEven ? styles.gridTableRowEven : styles.gridTableRowOdd
  }`;

  const deleteExtraService = async () => {
    try {
      await apiClient.delete(`/v1/extra-services/admin/${extraService._id}`);
      toast.success('Extra service was deleted successfully!');
    } catch (error) {
      logger.error('Error deleting extra service:', error);
    }
    handleRowTouched();
  };

  return (
    <>
      <div className={` ${classes} ${styles.gridTableRowFirst}`}>
        {extraService?.mentor?.fullName}
      </div>
      <div className={` ${classes}`}>
        {extraService?.serviceType.charAt(0).toUpperCase() + extraService?.serviceType.slice(1)}
      </div>
      <div className={` ${classes}`}>{extraService?.description}</div>
      <div className={` ${classes}`}>
        {extraService?.amount} {extraService?.currency}
      </div>
      <div className={` ${classes}`}>{moment(extraService?.createdAt).format('YYYY-MM-DD')}</div>
      <div className={`${classes}`}>{ExtraServiceStatus[extraService?.status]}</div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          minHeight: '120px',
          maxWidth: '140px',
        }}
        className={`${rowStyles.optionsContainer} ${classes} ${styles.gridTableRowLast}`}
      >
        <span
          style={{ margin: '0px 4px 0px 4px' }}
          onClick={() => {
            showEditModal({
              handleRowTouched: handleRowTouched,
              defaultData: extraService,
            });
          }}
        >
          <EditIcon style={{ cursor: 'pointer' }} className={rowStyles.editItem} />
        </span>
        <span
          style={{ margin: '0px 4px 0px 4px' }}
          onClick={(event) => {
            deleteExtraService();
          }}
        >
          <DeleteIcon style={{ cursor: 'pointer' }} />
        </span>
      </div>

      {EditServiceModal}
    </>
  );
};

export default ExtraServicesRow;
